export const CODE_LANGUAGE_MAP = Object.freeze({
    javascript: { extension: 'js', aliases: ['javascript', 'java script', 'js', 'jsx', 'node.js', 'nodejs', 'node js', 'ecmascript'] },
    typescript: { extension: 'ts', aliases: ['typescript', 'type script', 'ts', 'tsx'] },
    python: { extension: 'py', aliases: ['python', 'python3', 'py'] },
    java: { extension: 'java', aliases: ['java'] },
    csharp: { extension: 'cs', aliases: ['c#', 'c sharp', 'csharp'] },
    cpp: { extension: 'cpp', aliases: ['c++', 'c plus plus', 'cpp'] },
    c: { extension: 'c', aliases: ['c'] },
    go: { extension: 'go', aliases: ['golang', 'go lang', 'go'] },
    php: { extension: 'php', aliases: ['php'] },
    rust: { extension: 'rs', aliases: ['rust', 'rustlang'] },
    kotlin: { extension: 'kt', aliases: ['kotlin'] },
    ruby: { extension: 'rb', aliases: ['ruby'] },
    swift: { extension: 'swift', aliases: ['swift'] },
    dart: { extension: 'dart', aliases: ['dart'] },
    r: { extension: 'r', aliases: ['r language', 'r programming', 'r'] },
    sql: { extension: 'sql', aliases: ['sql', 'mysql', 'postgresql', 'postgres', 'sqlite', 't-sql', 'tsql', 'pl/sql', 'pl sql'] },
    markup: { extension: 'html', aliases: ['html', 'html5'] },
    css: { extension: 'css', aliases: ['css', 'css3'] },
    bash: { extension: 'sh', aliases: ['shell scripting', 'shell script', 'bash', 'shell', 'zsh', 'sh'] },
    powershell: { extension: 'ps1', aliases: ['powershell', 'power shell'] },
    matlab: { extension: 'm', aliases: ['matlab'] },
    lua: { extension: 'lua', aliases: ['lua'] }
})

const normalizeTitle = (value = '') => ` ${String(value)
    .toLowerCase()
    .replace(/[^a-z0-9+#.]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()} `

export const findCodeLanguage = (title) => {
    const normalizedTitle = normalizeTitle(title)
    let bestMatch = null

    Object.entries(CODE_LANGUAGE_MAP).forEach(([language, { aliases }]) => {
        aliases.forEach((alias) => {
            const normalizedAlias = normalizeTitle(alias).trim()
            const matchIndex = normalizedTitle.indexOf(` ${normalizedAlias} `)

            if (matchIndex === -1) return

            const isEarlierMatch = !bestMatch || matchIndex < bestMatch.index
            const isMoreSpecificMatch = matchIndex === bestMatch?.index && normalizedAlias.length > bestMatch.aliasLength

            if (isEarlierMatch || isMoreSpecificMatch) {
                bestMatch = { language, index: matchIndex, aliasLength: normalizedAlias.length }
            }
        })
    })

    return bestMatch?.language
}

export const resolveCodeLanguage = ({ lessonName, moduleName, fallbackLanguage }) => (
    findCodeLanguage(lessonName)
    || findCodeLanguage(moduleName)
    || fallbackLanguage
)
